import React from 'react';
import Header from 'components/header';

import Container from 'react-bootstrap/Container';

interface Props {
    children: JSX.Element | JSX.Element[]
}

const ContainerComponent: React.FC<Props> = ({ children }) => {
    return (
        <>
            <Header />
            <Container fluid>{children}</Container>
        </>
    );
};

export default ContainerComponent;
